import * as babylon from "@babylonjs/core";

export function createPathMesh(
  name: string,
  color: string,
  lineWidth: number,
  points: babylon.Vector3[],
  scene: babylon.Scene,
): babylon.Mesh {
  const lineMesh = babylon.CreateGreasedLine(
    name,
    {
      points,
    },
    {
      color: babylon.Color3.FromHexString(color),
      width: lineWidth,
      // This tells the material to decide the line width in canvas pixels instead of
      // coordinate-space units. That gives a nice-looking line-graph-like line instead
      // of a line whose size changes based on perspective distance.
      sizeAttenuation: true,
    },
    scene,
  );
  return lineMesh;
}
